import FormSubmitButton from '../../forms/FormSubmitButton';
import dom from '../dom';

/**
 * @param {HTMLFormElement} $form
 */
const disableFormControls = ($form) => {
  const $els = [...$form.elements].filter((el) => !el.disabled);

  $els.forEach(($el) => dom.disable($el));

  return {
    reenableControls: () => {
      $els.forEach(($el) => dom.enable($el));
    },
  };
};

/**
 * @param {HTMLFormElement} $form
 */
const disableForm = ($form) => {
  const { reenableControls } = disableFormControls($form);

  const $btnSubmit = [...$form.elements].find(($el) => $el.getAttribute('type') === 'submit');

  return {
    reenableForm: () => {
      reenableControls();

      if ($btnSubmit) {
        FormSubmitButton.resetButtonStyling($btnSubmit);
      }
    },
  };
};

export default disableForm;
